import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Anchor, Text } from '@zillow/constellation';

import { RMWContext } from 'app/shared/providers/RMWContext';

const propTypes = {
    disablePublishIfDuplicatePaidListingPosted: PropTypes.bool.isRequired,
    isActive: PropTypes.bool.isRequired,
};

const ErrorMessage = ({ disablePublishIfDuplicatePaidListingPosted, isActive }) => {
    const { paths: { listingDeclined } } = useContext(RMWContext);
    const accountVerificationEmail = 'account_verification@zillow.com';

    return (
        <div className="ErrorMessage">
            {(disablePublishIfDuplicatePaidListingPosted && !isActive) ? (
                <Text fontType="body">
                    This property is currently listed from another source.
                    &nbsp;
                    <Anchor href={listingDeclined} target="_blank">
                        Learn more
                    </Anchor>
                </Text>
            ) : (
                <Text fontType="body">
                    {!isActive ? 'This listing cannot be published'
                        : 'Your listing has been declined'}
                    . Please contact&nbsp;
                    <Anchor href={`mailto:${accountVerificationEmail}`} escape={true}>
                        Account Verification
                    </Anchor>
                    .
                </Text>
            )}
        </div>
    );
};

ErrorMessage.propTypes = propTypes;

export default ErrorMessage;
